<template>
	<Loader v-if="loading" />
	<div v-else>
		<div v-for="comment in record" class="margin-bottom">
			<textarea :disabled="saving" cols="60" rows="5" v-model="comment.comment"></textarea>
			<div class="small-margin-top">
				<button :disabled="saving" v-on:click="saveComment(comment)">Save</button>
			</div>
		</div>
		<div class="margin" v-if="record.length < 1">
			<textarea :disabled="saving" cols="60" rows="5" v-model="create_comment"></textarea>
			<div class="small-margin-top">
				<button :disabled="saving" v-on:click="createComment()">Create</button>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: [
    'id'
  ],
  data: () => ({
    loading: false,
    saving: false,
    record: {},
    create_comment: ''
  }),
  methods: {
    load () {
      Vue.$api.get('/order/' + this.id + '/comments', {}, {
        loader: toggle => this.loading = toggle,
        callback: data => this.record = data
      })
    },
    saveComment (comment) {
      Vue.$api.patch('/order/comment/' + comment.id, {
        comment: comment.comment
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => this.$emit('success')
      })
    },
    createComment () {
      Vue.$api.post('/order/' + this.id + '/comment', {
        comment: this.create_comment
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => {
          this.$emit('success')
        }
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
